import React, { useCallback, useEffect, useLayoutEffect, useMemo, useState } from "react";

import { Button, Col, Row } from "react-bootstrap";
import { UserService } from "app/_services/UserService/UserService";
import { normalizeDateTime, userDropdownLabel } from "app/_helpers/helper";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import { getAllActivity } from "app/_services/_globalConfiguration/Activity/ActivityService";
import { getAllAreaOfOperation } from "app/_services/ehs/ehsAreaOfOperationServices";
import { ACTIVE_MODULE } from "app/_constants/constant";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { Validation } from "app/_helpers/validation/Validation";
import { createVFL, updateVFL, getVFLByID } from "app/_services/ehs/VFLService";
import toastr from "toastr";
import VFLScheduleForm from "./component/VFLScheduleForm";
import { VFL_STATUS } from "./CONSTANTS";
import { confirmAlert } from "react-confirm-alert";

import {
  getAuthUser,
  isUserMM,
  IS_USER_SITE_HO,
  IS_USER_SITE_MINES,
  LOGGED_IN_USER_SITE_ID,
} from "../IncidentManagement/Helper";
import ViewComments from "../IncidentManagement/ViewComments";
import InputError from "app/Components/_form/InputError/InputError";
import {
  getActiveContractor,
  getContractor,
} from "app/_services/Contractor/ContractorService";
import { getAllContractorPerson } from "app/_services/UserManagement/ContractorPersonService";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

const initialForm = {
  vflExecutiveId: "",
  vflScheduledDateTime: "",
  vflCompletionDateTime: "",
  vflActualScheduledDateTime: "",
  vflActualCompletionDateTime: "",
  regionalOfficeId: "",
  mineId: "",
  departmentId: "",
  areaId: "",
  subAreaId: "",
  activityId: "",
  subActivityId: "",
  stateId: "",
  vflScheduledBy: "",
  vflCompletedBy: "",
  vflObservationId: "",
  vflWorkmenInteractionId: "",
  contractorInvolved: false,
  contractorsId: "",
};

const rules = [
  {
    field_name: "vflExecutiveId",
    label: "VFL Executive",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "vflScheduledDateTime",
    label: "VFL Scheduled Date",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "mineId",
    label: "Mine Name",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "departmentId",
    label: "Department",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "areaId",
    label: "Area",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "subAreaId",
    label: "Sub Area",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "activityId",
    label: "Activity",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "subActivityId",
    label: "Sub Activity",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "contractorsId",
    label: "Select Options",
    type: "string",
    isRequired: false,
  },
];

const VFLSchedule = ({
  match: {
    params: { id },
  },
  history,
}) => {
  const [form, setForm] = useState({ ...initialForm });
  const [error, setError] = useState({ ...initialForm });

  // DataBase DATA
  const [sites, setSites] = useState([]);
  const [area, setArea] = useState([]);
  const [contractors, setContractors] = useState([]);
  const [subArea, setSubArea] = useState([]);
  const [activity, setActivity] = useState([]);
  const [subActivity, setSubActivity] = useState([]);
  const [loading, setLoading] = useState(false);

  const [VFLExecutives, setVFLExecutives] = useState([]);

  const mines = useMemo(() => {
    const isUserSiteHo = IS_USER_SITE_HO();
    const userSiteId = LOGGED_IN_USER_SITE_ID();

    return sites.filter(
      (site) => +site.siteType === 3 && (isUserSiteHo || +site.id === userSiteId)
    );
  }, [sites]);

  /**************** Form Method ************************/

  const onChangeDate = useCallback((momentDate, name) => {
    if (typeof momentDate === "string") return;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: momentDate.format("YYYY-MM-DD HH:mm:ss"),
    }));
  }, []);

  /*****************************Dependent Data Function ****************/
  const changeDependentDropdown = useCallback(
    (name, value) => {
      switch (name) {
        case "areaId":
          if (form.areaId !== value) return { subAreaId: "" };
          break;
        case "activityId":
          if (form.activityId !== value) return { subActivityId: "" };
          break;
        default:
          break;
      }
    },
    [form.activityId, form.areaId]
  );

  const mineDependentData = useCallback(
    (value) => {
      let obj = {};

      const selectedMines = mines.find((mine) => mine.id === value) || {};

      obj.regionalOfficeId = selectedMines?.parentSite?.name;
      obj.stateMasterId = selectedMines?.state?.name;
      obj.countryMasterId = selectedMines?.state?.country_master?.name;
      obj.locationSiteId = selectedMines?.siteId;
      obj.roId = selectedMines?.parentSite?.id;
      obj.roName = selectedMines?.parentSite?.name;
      obj.roSiteId = selectedMines?.parentSite?.siteId;

      setForm((prev) => ({ ...prev, ...obj }));
    },
    [mines]
  );

  const areaDependentData = useCallback(
    (value) => {
      const otherOption = [{ id: 0, name: "Other" }];

      const subAreaData = area.find((x) => x.id === value)?.subAreaOfOperation || [];

      setSubArea(value ? [...subAreaData, ...otherOption] : []);
    },
    [area]
  );

  const activityDependentData = useCallback(
    (value) => {
      const subActivityData = activity.find((x) => x.id === value)?.subActivity || [];
      setSubActivity(subActivityData);
    },
    [activity]
  );

  const onChange = useCallback(
    ({ target: { name, type, value, checked } }) => {
      console.log("name", name);
      console.log("value", value);

      setForm((prevForm) => {
        const updates = {
          ...prevForm,
          [name]: type === "checkbox" ? checked : value,
        };

        if (name === "mineId") {
          const selected = sites.find((site) => site.id === +value);
          if (selected) {
            updates.stateMasterId = selected.state.id;
            updates.countryMasterId = selected.state.country_master?.id;
            updates.locationSiteId = selected.siteId;
            if (selected.siteType === 3) {
              updates.roId = selected.parentSite?.id;
              updates.roName = selected.parentSite?.name;
              updates.roSiteId = selected.parentSite?.siteId;
            } else if (selected.siteType === 2) {
              updates.roId = selected.id;
              updates.roName = selected.name;
              updates.roSiteId = selected.siteId;
            } else {
              updates.roId = "";
              updates.roName = "";
              updates.roSiteId = "";
            }
          } else {
            updates.stateMasterId = "";
            updates.countryMasterId = "";
            updates.locationSiteId = "";
            updates.roId = "";
            updates.roName = "";
            updates.roSiteId = "";
          }
        }

        if (name === "contractorInvolved" && !value) {
          updates.contractorsId = "";
        }

        const extraToChange = changeDependentDropdown(name, value);

        return { ...updates, ...extraToChange };
      });
    },
    [changeDependentDropdown, sites]
  );

  /*************** Submit Method ************************/
  const onSubmit = async (vflStatus = null, isBack = false, executiveReturn = false) => {
    const errorObj = Validation(
      form,
      rules.map((d) => ({
        ...d,
        isRequired:
          d.field_name === "contractorsId" && form?.contractorInvolved
            ? true
            : d.isRequired,
      }))
    );
    if (
      form?.id &&
      !form.reviewCompletionSummary &&
      form?.vflStatus !== VFL_STATUS.draft &&
      vflStatus !== null
    ) {
      errorObj.reviewCompletionSummary = "Message is Required";
    }

    setError(errorObj);

    if (Object.values(errorObj).filter((d) => d !== "").length) return;
    setLoading(true);
    const formData = {
      ...form,
      vflStatus: vflStatus || form.vflStatus || "draft",
      saveAs: executiveReturn ? true : false,
    };

    if (isBack) formData.isBack = true;

    let response = await (id ? updateVFL(id, formData) : createVFL(formData));
    setLoading(false);
    if (response?.message === "VFL Already Exists") {
      createDuplicateRecord(response?.alreadyExistingVFL, formData);
    }
    if (!response?.status) {
      return toastr.error(response?.message);
    }

    toastr.success(response.message || "Success.");
    history.push(`/health-safety-and-environment/vfl`);
  };
  //confirm to Duplicate record
  const createDuplicateRecord = async (alreadyExistingVFL, formData) => {
    formData.confirmToDuplicate = true;
    confirmAlert({
      title: `VFL with this data may already exist (VFL ID:${alreadyExistingVFL[0].vflId}). Do you still want to create another one?`,
      message: "",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            setLoading(true);
            let response = await (id ? updateVFL(id, formData) : createVFL(formData));
            setLoading(false);
            if (!response?.status) return toastr.error(response?.message);
            toastr.success(response.message || "Success.");
            history.push(`/health-safety-and-environment/vfl`);
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  /**************** Use Effect *********************/

  // get Api data
  useEffect(() => {
    UserService.getUsers("filter[status]=1").then((response) => {
      if (!response?.data) return;
      const userSiteId = LOGGED_IN_USER_SITE_ID();
      const loggedInUserData = getAuthUser();

      setVFLExecutives(
        response.data
          .filter((user) => {
            return (
              (user?.accessPermissions || []).filter(
                (d) => d.permission === "vflOfficer" && d.permissionValue === "1"
              ).length > 0 &&
              user?.role?.roleLable != "1" &&
              user?.role?.roleLable != "6" &&
              user?.role?.roleLable != "7" &&
              user.email_verify === 1 &&
              user?.employee &&
              +user?.employee?.ehsSite?.siteType ===
                +loggedInUserData?.user?.employee?.ehsSite?.siteType &&
              +user?.employee?.ehsSite?.id === +userSiteId
            );
          })
          .map((user) => ({
            label: userDropdownLabel(user),
            id: user.id,
          }))
      );
    });

    getAllSites("filter[status]=1&filter[activeStatus]=active").then((response) => {
      if (!response?.data) return;

      setSites(response.data);
    });

    getAllAreaOfOperation().then((response) => {
      if (!response?.data) return;
      setArea(response.data);
    });

    getAllActivity().then((response) => {
      if (!response?.data) return;

      setActivity(response.data);
    });

    getActiveContractor().then((response) => {
      if (!response?.data) return;

      setContractors(response.data);
    });
  }, []);

  useEffect(() => {
    if (!id) return;

    getVFLByID(id).then((response) => {
      if (!response?.status) {
        history.push("/health-safety-and-environment/vfl");
        toastr.error(response?.message || "Something went Wrong");
        return;
      }
      if (!response?.data) return;

      setForm((prev) => ({
        ...prev,
        ...response.data,
        regionalOfficeId: prev?.regionalOfficeId,
        date: normalizeDateTime(response.data.date),
        dependentFlag: true,
        contractorsId:
          response.data?.contractorsId === null ? "" : response.data?.contractorsId,
      }));
    });
  }, [id]);

  useEffect(() => {
    mineDependentData(form.mineId);
  }, [form.mineId, mineDependentData]);

  useEffect(() => {
    areaDependentData(form.areaId);
  }, [areaDependentData, form.areaId]);

  useEffect(() => {
    activityDependentData(form.activityId);
  }, [activityDependentData, form.activityId]);

  const vflPreviousAndNextButtonStatusAndTitle = (status, executiveReturn) => {
    const isUserSiteHo = IS_USER_SITE_HO();
    switch (status) {
      case VFL_STATUS.draft:
        if (isUserSiteHo) {
          return [null, null, VFL_STATUS.scheduled, "Submit for Approval"];
        } else {
          return [null, null, VFL_STATUS.scheduled, "Submit for Mines Manager Approval"];
        }
      case VFL_STATUS.scheduled:
        if (executiveReturn) {
          if (isUserSiteHo) {
            return [null, null, VFL_STATUS.scheduled, "Submit for Approval"];
          } else {
            return [
              null,
              null,
              VFL_STATUS.scheduled,
              "Submit for Mines Manager Approval",
            ];
          }
        } else
          return [null, "Reject VFL Request", VFL_STATUS.assigned, "Approve VFL Request"];

      default:
        if (isUserSiteHo) {
          return [null, null, VFL_STATUS.scheduled, "Submit for Approval"];
        } else {
          return [null, null, VFL_STATUS.scheduled, "Submit for Mines Manager Approval"];
        }
    }
  };

  useLayoutEffect(() => {
    setForm((prev) => {
      if (IS_USER_SITE_MINES()) {
        const obj =
          sites.length !== 0
            ? {
                mineId: sites[0]?.id,
                stateMasterId: sites[0]?.state.id,
                countryMasterId: sites[0]?.state.country_master?.id,
                locationSiteId: sites[0]?.siteId,
                roId: sites[0]?.parentSite?.id,
                roName: sites[0]?.parentSite?.name,
                roSiteId: sites[0]?.parentSite?.siteId,
              }
            : {};
        return { ...prev, ...obj };
      } else return prev;
    });
  }, [sites]);

  const [, previousTitle, nextStatus, nextTitle] = vflPreviousAndNextButtonStatusAndTitle(
    form.vflStatus,
    form?.executiveReturn
  );

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Visible Felt Leadership",
            path: "/health-safety-and-environment/vfl",
          },
          // {
          //   name: "My VFLs",
          //   path: "/health-safety-and-environment/vfl/my",
          // },
          { name: "Schedule VFL" },
        ]}
        module={ACTIVE_MODULE.vfl}
      />

      <div className="card p-3">
        <div className="simple-card-title justify-content-between">
          <h3 className="text-capitalize mb-0">Schedule VFL</h3>
          <BackBtn url={"/health-safety-and-environment/vfl"} />
          {/* <BackBtn url={"/health-safety-and-environment/vfl"} /> */}
          <div style={{ marginRight: "135px" }}>
            {form.vflId && (
              <span className="mr-3">
                VFL ID: <strong>{form.vflId}</strong>
              </span>
            )}
          </div>
        </div>

        <div className="ehsFormWrapper">
          <VFLScheduleForm
            form={form}
            onChange={onChange}
            onChangeDate={onChangeDate}
            error={error}
            VFLExecutives={VFLExecutives}
            mines={mines}
            // Department={Department}
            area={area}
            subArea={subArea}
            activity={activity}
            subActivity={subActivity}
            sites={sites}
            contractors={contractors}
          />
        </div>

        {form?.vflStatus && form?.vflStatus !== VFL_STATUS.draft && (
          <div className="ehsFormWrapper">
            <Row>
              <Col lg={12} className="reviewerInputsComments">
                {/* {form.isBack === 1 && <p style={{ color: "red" }}>{form?.backData?.length > 0 && form?.backData[form.backData.length - 1]?.comment}</p>} */}
                {/* <IncidentComments comments={comments} setComments={setComments} type={commentTypes.investigation} viewOnly /> */}
                <ViewComments
                  hideNotApplicable
                  title={"Workflow Inputs"}
                  comments={form?.incidentReviewsData || []}
                />
                <div className="addReviewerInput">
                  <textarea
                    class="form-control"
                    style={{ height: "88px" }}
                    name="reviewCompletionSummary"
                    onChange={onChange}
                    value={form.reviewCompletionSummary}
                    maxLength={500}
                    placeholder={`${
                      form?.vflAtLabel !== "so" ? "Mines Manager " : "Safety Officer "
                    } Input`}
                  />
                  {error["reviewCompletionSummary"] && (
                    <InputError error={error["reviewCompletionSummary"]} />
                  )}
                </div>
              </Col>
            </Row>
          </div>
        )}

        {!loading ? (
          <div className="mb-2 text-center">
            {previousTitle && (
              <Button
                type="submit"
                onClick={() => onSubmit(null, true)}
                variant="primary"
                className="m-1 text-capitalize mr-2"
              >
                {previousTitle}
              </Button>
            )}

            {form?.vflAtLabel !== "mm" && (
              <Button
                type="submit"
                onClick={() => onSubmit(null, null, form?.executiveReturn)}
                variant="primary"
                className="m-1 text-capitalize mr-2"
              >
                Save as Draft
              </Button>
            )}
            {nextTitle && nextStatus && (
              <Button
                type="submit"
                onClick={() => onSubmit(nextStatus)}
                variant="primary"
                className="m-1 text-capitalize mr-2"
              >
                {nextTitle}
              </Button>
            )}
          </div>
        ) : (
          <NetZeroLoader addZIndex={true} />
        )}
      </div>
    </>
  );
};

export default VFLSchedule;
